import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/education-concept-illustration_114360-7938.jpg';

function SpecialEducationSupport() {
  const [Faq, setFaq] = useState(0); // first dropdown open by default
  const titleRef = useRef(null);
  const [titleColor, setTitleColor] = useState('');

  useEffect(() => {
    if (titleRef.current) {
      const c = window.getComputedStyle(titleRef.current).color;
      setTitleColor(c);
    }
  }, []);

  // match reference page structure/styles
  const liRow = { display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '12px' };
  const icon = { marginTop: '4px', flex: '0 0 auto' };
  const kv = { display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: 0 };
  const keyText = { fontWeight: 700, fontSize: '1.1rem', lineHeight: 1.35, color: '#0f172a' };
  const valText = { fontSize: '1rem', lineHeight: 1.6, color: '#334155' };
  const overviewText = { color: titleColor || '#0f172a', fontSize: '1.05rem', lineHeight: 1.6, margin: '8px 0 16px' };

  const sections = [
    {
      Que: 'Academic Transcript Rules (Official vs. Unofficial)',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Official (accepted):</span>
              <span style={valText}>
                (1) Uploaded in GTSCompass by a Tennessee-approved EPP; (2) mailed/parcel/hand-delivered in the original
                sealed registrar envelope; or (3) sent electronically by a recognized clearinghouse directly to
                <u>Educator.Licensure@gts.gov</u>.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Unofficial (rejected):</span>
              <span style={valText}>
                Not in a sealed registrar envelope, files uploaded by the educator in GTSCompass, files emailed by an individual,
                or anything showing signs of tampering (these are securely shredded and the sender notified if possible).
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Out-of-Country Transcripts',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Required evaluation:</span>
              <span style={valText}>
                Submit an original <strong>course-by-course</strong> evaluation for all degrees, with copies of the transcripts.
                Paper must be in a sealed envelope from the evaluator; electronic delivery must come through a secure evaluator account.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Recognized Evaluators (examples)',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>NACES / AICE members:</span>
              <span style={valText}>
                World Education Services (WES), SpanTran, Educational Credential Evaluators (ECE), IERF, AACRAO,
                Academic Credentials Evaluation Institute (ACEI), Josef Silny & Associates, and others approved by OELP.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Submission Methods',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>GTSCompass (EPP uploads):</span>
              <span style={valText}>Official transcripts uploaded by Tennessee-approved EPPs are accepted.</span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Mail/Hand Delivery:</span>
              <span style={valText}>
                Use the original, sealed registrar envelope. No photocopies or opened envelopes.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Electronic:</span>
              <span style={valText}>
                Sent by an approved clearinghouse on behalf of the institution directly to the licensure office email.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Licensure Office (OELP) Contact',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Address & phone:</span>
              <span style={valText}>
                Office of Educator Licensure & Preparation • 123 James White Pkwy, 12th Floor, Washington, GTS 12345 •
                Tel: (123) 532-4885 • Fax: (123) 532-1448
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Website & email:</span>
              <span style={valText}>
                gts.gov/education • Educator.Licensure@gts.gov (clearinghouse deliveries only; individuals should not email transcripts)
              </span>
            </div>
          </li>
        </ul>
      ),
    },
    {
      Que: 'Family & Student Supports',
      Answer: (
        <ul className="list-unstyled list-style">
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>IEPs & accommodations:</span>
              <span style={valText}>
                Coordination with schools to develop or update IEPs, plus access to assistive technologies and learning supports.
              </span>
            </div>
          </li>
          <li style={liRow}>
            <i className="fa-solid fa-circle-arrow-right" style={icon} />
            <div style={kv}>
              <span style={keyText}>Transition planning:</span>
              <span style={valText}>
                Guidance on services across grade transitions and into post-secondary or employment pathways.
              </span>
            </div>
          </li>
        </ul>
      ),
    },
  ];

  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img
                src={SubDeptImage}
                className="img-fluid"
                alt="Special Education and Learning Support Services"
              />
            </div>

            <div className="department-details-content-box">
              <h4 ref={titleRef} className="department-details-title">
                Special Education and Learning Support Services
              </h4>

              {/* Overview (always visible, same color as title but smaller) */}
              <p style={overviewText}>
                We support inclusive education for students with diverse learning needs—IEPs, specialized instruction,
                assistive technology, and family guidance—so every learner can access a high-quality education.
              </p>

              {/* Download button BELOW overview, ABOVE other sections */}
              <div style={{ margin: '0 0 16px' }}>
                <a
                  href="/guides/GTSacademic-transcripts-operating-procedure.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#e75934',
                    textDecoration: 'none',
                    border: '1px solid #e75934',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e75934';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#e75934';
                  }}
                >
                  <i className="fa-solid fa-file-pdf" style={{ marginRight: '8px', fontSize: '14px' }} />
                  Download Academic Transcripts Operating Procedures (PDF)
                </a>
              </div>
            </div>

            {/* Accordion (expanded information) */}
            <div className="accordian-box">
              {sections.map((item, index) => (
                <div className={`accordian-box-item ${Faq !== index && 'active'}`} key={index}>
                  <div className="accordian-title">
                    <h5>{item.Que}</h5>
                    <i
                      className="fa-solid fa-angle-right"
                      onClick={() => setFaq(index)}
                      role="button"
                      aria-label={`Toggle ${item.Que}`}
                    />
                  </div>

                  {Faq === index && (
                    <div className="accordian-content" style={{ display: 'block' }}>
                      {item.Answer}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div style={{ marginTop: 12 }}>
              <Link to="/department/education">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default SpecialEducationSupport;
